import React, {lazy,useContext} from 'react';
import {Route, Routes, Navigate} from 'react-router-dom';
import contents from '../../routes/contentRoutes';
import Login from '../../pages/MekaLogin';
import AuthContext from '../../contexts/authContext';
const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));
const ContentRoutes = () => {
    const {user,setUser,bag,setBag,setMainMenu}=useContext(AuthContext)
    return (<Routes>
        <Route path={"/signon"} element={<Login />}/>
        {(user !== null && user !== false) && (
            <>
                {contents.map((page) => (
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    <Route key={page.path} {...page}/>
                ))}
            </>
        )}
        {user === null &&
            <Route path={"*"} element={<Navigate to="/signon"/>}/>}
    </Routes>);
};
export default ContentRoutes;
